export default () => (
  <path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20ZM8.836 8.836a.934.934 0 0 1 1.324 0l1.836 1.836 1.836-1.836a.937.937 0 0 1 1.324 1.324l-1.836 1.836 1.836 1.836a.937.937 0 0 1-1.324 1.324l-1.836-1.836-1.836 1.836a.937.937 0 0 1-1.324-1.324l1.836-1.836-1.836-1.836a.934.934 0 0 1 0-1.324Z" />
);
